export const genreIcons = [
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "avant_garde",
      similarGenres: "avant garde,avant garde jazz,avant garde metal",
      name: "Avant Garde"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "blues",
      similarGenres:
        "blues,blues guitar,blues revival,blues rock,blues-rock,british blues,chicago blues,classic blues,contemporary blues,country blues,delta blues,electric blues,juke joint blues,louisiana blues,memphis blues,modern blues,modern electric blues,new orleans blues,slide guitar blues,soul blues,texas blues",
      name: "Blues"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "classic_rock",
      similarGenres: "classic rock",
      name: "Classic Rock"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "classical",
      similarGenres:
        "classical,classical pop,contemporary classical music,crossover classical,modern classical",
      name: "Classical"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "comedy",
      similarGenres: "comedy,comedy rock",
      name: "Comedy"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "country",
      similarGenres:
        "country,alternative country,country honky tonk,classic country,modern country,hillbilly,rockabilly,bluegrass,country pop,outlaw country,progressive country,texas country",
      name: "Country"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "electronic",
      similarGenres:
        "electronic,electro,electro house,electro-funk,electro-industrial,experimental electronic",
      name: "Electronic"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "folk",
      similarGenres:
        "folk,acid folk,alternative folk,contemporary folk,country folk,electric folk,folk pop,folk revival,folk rock,folk pop,indie folk,neo folk,pop folk,psychedelic folk,stomp and holler,traditional folk,urban folk",
      name: "Folk"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "hip_hop",
      similarGenres:
        "hip hop,classic hip hop,rap,west coast hip hop,alternative hip hop,east coast hip hop,electro hip hop,experimental hip hop,independent hip hop,indie hip hop,jazz hip hop,old school hip hop,southern hip hop",
      name: "Hip Hop"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "holiday",
      similarGenres: "holiday",
      name: "Holiday"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "indie",
      similarGenres:
        "indie rock,geek rock,lo fi,math rock,indie folk,indie hip hop,indie,indy",
      name: "Indie"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "jazz",
      similarGenres:
        "jazz,jazz blues,jazz funk,jazz fusion,jazz hip hop,jazz rock,jazz vocal,modern jazz,new orleans jazz,soul jazz,traditional jazz",
      name: "Jazz"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "latin",
      similarGenres:
        "latin,latin jazz,jazz latino,latin alternative,latin folk,latin hip hop,latin pop,latin music,latin rap,latin rock,latin ska",
      name: "Latin"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "motown",
      similarGenres:
        "motown,classic motown,soul,memphis soul,old school soul,soul music,soul,rhythm and blues,rhythm & blues",
      name: "Motown"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "new_age",
      similarGenres: "new age,new age music",
      name: "New Age"
    }
  },

  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "pop",
      similarGenres:
        "pop 60s,pop 80s,pop ,acoustic pop,alternative pop,pop rock ,dance pop,folk pop,jangle pop,pop country,pop punk,pop rap,pop folk,psychedelic pop",
      name: "Pop"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "punk",
      similarGenres:
        "punk,punk rock,acoustic punk,art punk,anarcho punk,classic punk,cowpunk,dance-punk,cyberpunk,emo punk,folk punk,garage punk,hardcore punk,indie punk,old school punk,political punk,skate punk,street punk",
      name: "Punk"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "rock",
      similarGenres:
        "rock,punk rock,classic rock,college rock,dance rock,electro rock,folk rock,garage rock,jam band,hard rock,modern rock,psychedelic stoner rock,punk southern rock,80s rock,90s rock,70s rock,60s rock,alternative rock,acoustic rock,acid rock,metal,heavy metal",
      name: "Rock"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "soft_rock",
      similarGenres: "soft rock,easy listening",
      name: "Soft Rock"
    }
  },
  {
    genre: {
      checkedState: false,
      isSelected: false,
      state: "off",
      genre: "world",
      similarGenres: "world,world music,world beat,world fusion",
      name: "World"
    }
  }
];

export function getGenres() {
  genreIcons.forEach(g => {
    g.genre.checkedState = false;
    g.genre.isSelected = false;
  });

  return genreIcons;
}

export function getGenre(genre) {
  return genreIcons.filter(g => genre === g.genre.genre);
}

export function getCheckedGenres() {
  return genreIcons.filter(genre => {
    return genre.genre.checkedState;
  });
}

export function setCheckedGenre(genre) {
  const checkedGenre = genreIcons.filter(g => {
    return g.genre.genre === genre;
  });
  checkedGenre[0].genre.checkedState = true;
  return checkedGenre;
}

export function toggleGenre(genre) {
  return genreIcons.map(g => {
    if (g.genre.genre === genre.genre.genre) {
      g.genre.checkedState = !genre.genre.checkedState;
    }
    return g;
  });
}

export function unCheckGenre(genre) {
  return (genre.genre.checkedState = false);
}

export function getSimilarGenres() {
  const genres = getCheckedGenres();
  return genres
    .map(genre => {
      const similarGenres = genre.genre.similarGenres.split(",");
      return similarGenres
        .map(sg => {
          return `spotify.genres:${sg}`;
        })
        .join("_");
    })
    .join("_");
}

export function getGenreTitles() {
  return genreIcons
    .reduce((acc, genre) => {
      if (genre.genre.checkedState) {
        acc.push(genre.genre.name);
      }
      return acc;
    }, [])
    .join("& ");
}

export function hasActiveGenres() {
  return (
    genreIcons.filter(genre => {
      return genre.genre.checkedState;
    }).length > 0
  );
}

export function isChecked(genre) {
  return genre.genre.checkedState === true;
}

export function clearGenres() {
  return genreIcons.map(genre => {
    genre.genre.checkedState = false;
    return genre;
  });
}
